// extracted by mini-css-extract-plugin
export var text = "_ae-0";